import { render, staticRenderFns } from "./ConceptOrders.vue?vue&type=template&id=79a35489&scoped=true"
import script from "./ConceptOrders.vue?vue&type=script&lang=ts"
export * from "./ConceptOrders.vue?vue&type=script&lang=ts"
import style0 from "./ConceptOrders.vue?vue&type=style&index=0&id=79a35489&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a35489",
  null
  
)

export default component.exports